import { createContext, FC, PropsWithChildren, useCallback, useEffect, useMemo, useState } from 'react'

import { end8x8Chat, is8x8ChatActive, start8x8Chat, watch8x8ChatActive } from '../utils/8x8-chat'

interface IChatContext {
  chatActive: boolean
  startChat: () => void
  endChat: () => void
}

// Defaults call the util directly so consumers still work when rendered without the provider.
export const ChatContext = createContext<IChatContext>({
  chatActive: false,
  startChat: () => start8x8Chat(),
  endChat: () => end8x8Chat(),
})

const ChatProvider: FC<PropsWithChildren> = ({ children }) => {
  const [chatActive, setChatActive] = useState<boolean>(is8x8ChatActive())

  useEffect(() => watch8x8ChatActive(setChatActive), [])

  // start8x8Chat is a no-op until 8x8 has initialized, so read the resulting state back from the util.
  const startChat = useCallback(() => {
    start8x8Chat()
    setChatActive(is8x8ChatActive())
  }, [])

  const endChat = useCallback(() => {
    end8x8Chat()
    setChatActive(false)
  }, [])

  const value = useMemo(() => ({ chatActive, startChat, endChat }), [chatActive, startChat, endChat])

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>
}

export default ChatProvider
